import { Location } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { FilterStripDto } from '@shared/src/components/core/maintenance/filter/FilterStripDtos';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { HDateHour } from "@shared/src/datatypes/HDateHour";
import { HLong } from '@shared/src/datatypes/HLong';
import { HString } from '@shared/src/datatypes/HString';
import { BookingFilterTypes } from '@shared/src/enums/BookingFilterTypes';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BookingController } from '@shared/src/controllers/booking/booking.controller';
import { BookingCardItemDto } from '@shared/src/dtos/booking/BookingCardItemDto';
import { SharedAsideFactory } from '../components.api';
import { PortAddressOriginDestinationSelectorDto } from '../portaddress/shared.port.address.origin.destination.selector.component';
import { BookingSearchByTextDto } from '@shared/src/controllers/booking/BookingSearchByTextDto';
import { BookingFilterStatus } from '@shared/src/public-api';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { fadeInOut, slideInOutHorizontal } from '@shared/src/animations';

@Component({
	selector: 'shared-active-bookings',
	templateUrl: './shared.active.bookings.html',
	styleUrls: ['./shared.active.bookings.scss'],
	animations: [slideInOutHorizontal]
})
export class SharedActiveBookings implements OnInit {

	searchTextUpdate = new Subject<string>();

	public static SLICECOUNTINITIAL: number = 100;
	public static SLICECOUNTMORE: number = 100;

	public useIonic: boolean = false;
	constructor(public activatedRoute: ActivatedRoute,
		public router: Router, public location: Location, public bookingController: BookingController,
		@Inject('HomeController') protected homeController: HomeController,
		@Inject("SecurityController") protected securityController: SecurityController,
		@Inject('SharedAsideFactory') public sharedAsideFactory: SharedAsideFactory,
		protected socketController: SocketController) {

		// Debounce search.
		this.searchTextUpdate.pipe(
			debounceTime(HomeController.DEFAULT_BOUNCE_BUTTON_TIME),
			distinctUntilChanged())
			.subscribe(value => {
				//Abans d'anar a la base de dades, hem de tenir mínim 3 digits o que el searchtext sigui "" (voldrà dir que borra tot per tornar a començar)
				if (HString.isNullOrNullString(this.searchText))
					this.loadData(true, false);
				else if (this.searchText.length > 2)
					this.loadExactKeyData(false);
			});

		this.socketController.notificationReloadHome$.subscribe(e => {
			this.loadData(true, false);
		});

		if (homeController.useIonic)
			this.useIonic = homeController.useIonic();

		//Fem subscribe per detectar només el location.back i location.forward que s'executen  només al anar endevant i enrera en els botons del navegador
		//Nomes ho fem amb aquests dos casos ja que o sinó esta constantment detectant canvis al canviar els parametres de url en el routeTo
		this.location.subscribe(
			((value: PopStateEvent) => {
				console.log(value);
				this.loadParametersLocation();
			}),
			(ex => {
				console.log("Error occured postate event")
				console.log(ex);
			})
		);
	}

	public searchText: string = "";

	public filterStatus: FilterStripDto;// = new FilterStripDto();
	public filterBookingTypes: FilterStripDto;// = new FilterStripDto();
	public bookingSearchByText: BookingSearchByTextDto = BookingSearchByTextDto.buildPage("", [], 0, 50);
	public bookings: Array<BookingCardItemDto> = [];
	public _bookings: Array<BookingCardItemDto> = [];
	public bookingsExactKey: Array<BookingCardItemDto> = [];
	public filterMetadataExactKey: any = {};
	public filterMetadata: any = {};

	public actions: ActionsStripDto;

	ngOnInit(): void {

		this.bookingController.getActions(null).subscribe(e => {
			this.actions = ActionsStripDto.buildFromActionsStripDto(e);
		});

		this.portAddressOriginDestination = PortAddressOriginDestinationSelectorDto.buildActiveBookings();

		this.sliceCount = SharedActiveBookings.SLICECOUNTINITIAL;
		this.loadParameters();

		this.router.events.subscribe((event: RouterEvent) => {
			if (event instanceof NavigationEnd) {
				this.loadParametersLocation();
			}
		});
	}

	public allLoaded: boolean = false;


	public loadParameters() {

		const routeParams = this.activatedRoute.snapshot.paramMap;
		const queryParams = this.activatedRoute.snapshot.queryParamMap;

		let origin = routeParams.has(BookingController.PARAMETERORIGINIDNAME) ? routeParams.get(BookingController.PARAMETERORIGINIDNAME) : queryParams.get(BookingController.PARAMETERORIGINIDNAME);
		if (origin)
			this.originId = +origin;

		let destination = routeParams.has(BookingController.PARAMETERDESTINATIONIDNAME) ? routeParams.get(BookingController.PARAMETERDESTINATIONIDNAME) : queryParams.get(BookingController.PARAMETERDESTINATIONIDNAME);
		if (destination)
			this.destinationId = +destination;

		let booking = routeParams.has(BookingController.PARAMETERBOOKINGIDNAME) ? routeParams.get(BookingController.PARAMETERBOOKINGIDNAME) : queryParams.get(BookingController.PARAMETERBOOKINGIDNAME);
		if (booking)
			this.bookingId = +booking;
		else {
			this.selectedBooking = null;
			this.actionId = routeParams.has(BookingController.PARAMETERACTIONNAME) ? routeParams.get(BookingController.PARAMETERACTIONNAME) : queryParams.get(BookingController.PARAMETERACTIONNAME);
		}

		this.bookingSearchByText.activeFilterKeys = new Array();
		for (var rft in BookingFilterStatus) {
			let rftUrl = routeParams.has(rft) ? routeParams.get(rft) : queryParams.get(rft);
			if (rftUrl != null && rftUrl == "true")
				this.bookingSearchByText.activeFilterKeys.push(rft);
		}
		for (var rft in BookingFilterTypes) {
			let rftUrl = routeParams.has(rft) ? routeParams.get(rft) : queryParams.get(rft);
			if (rftUrl != null && rftUrl == "true")
				this.bookingSearchByText.activeFilterKeys.push(rft);
		}

		let searchtext = queryParams[BookingController.PARAMETERSEARCHTEXTNAME];
		if (searchtext)
			this.searchText = searchtext;

		this.allLoaded = true;
	}
	public loadParametersLocation() {

		let path = this.location.path();
		if (path == "")
			return;

		let tree = this.router.parseUrl(path);
		let queryParams = tree.queryParams;

		let origin = queryParams[BookingController.PARAMETERORIGINIDNAME];
		if (origin)
			this.originId = +origin;

		let destination = queryParams[BookingController.PARAMETERDESTINATIONIDNAME];
		if (destination)
			this.destinationId = +destination;

		let booking = queryParams[BookingController.PARAMETERBOOKINGIDNAME];
		if (booking)
			this.bookingId = +booking;
		else {
			this.bookingId = 0;
			this.selectedBooking = null;
			this.actionId = queryParams[BookingController.PARAMETERACTIONNAME];
		}

		this.bookingSearchByText.activeFilterKeys = new Array();
		for (var rft in BookingFilterTypes) {
			let rftUrl = queryParams[rft];
			if (rftUrl != null && rftUrl == "true")
				this.bookingSearchByText.activeFilterKeys.push(rft);
		}

		let searchtext = queryParams[BookingController.PARAMETERSEARCHTEXTNAME];
		if (searchtext)
			this.searchText = searchtext;

		this.allLoaded = true;
	}

	routeTo() {

		if (!this.allLoaded || this.useIonic)
			return;

		let object = {};

		if (!HLong.isNullOrNullLong(this.bookingId))
			object[BookingController.PARAMETERBOOKINGIDNAME] = this.bookingId;
		else {
			if (!HLong.isNullOrNullLong(this.originId))
				object[BookingController.PARAMETERORIGINIDNAME] = this.originId;
			if (!HLong.isNullOrNullLong(this.destinationId))
				object[BookingController.PARAMETERDESTINATIONIDNAME] = this.destinationId;

			if (this.bookingSearchByText && this.bookingSearchByText.activeFilterKeys) {
				this.bookingSearchByText.activeFilterKeys.forEach(element => {
					object[element] = "true";
				});
			}

			if (!HString.isNullOrNullString(this.searchText))
				object[BookingController.PARAMETERSEARCHTEXTNAME] = this.searchText;

			if (!HString.isNullOrNullString(this.actionId))
				object[BookingController.PARAMETERACTIONNAME] = this.actionId;
		}

		//Aqui no estem rederigint, només estem actualtzant els queryParams perque es vegi reflectida la URL. 
		//Al no redirigir (que ja es el que volem perquè no es necessàri), no està refrescant la pagina i no entrarà pel ngOnInit()
		this.router.navigate([".", {}], { relativeTo: this.activatedRoute, queryParams: object, queryParamsHandling: '' });

	}

	public _bookingId: number;
	public get bookingId(): number {
		return this._bookingId;
	}
	public set bookingId(value: number) {
		if (this._bookingId === value)
			return;
		this._bookingId = value;
	}

	public _destinationId: number;
	public get destinationId(): number {
		return this._destinationId;
	}
	public set destinationId(value: number) {
		if (this._destinationId === value)
			return;
		this._destinationId = value;
		if (this.portAddressOriginDestination != null)
			this.portAddressOriginDestination.destinationId = value;
	}
	public _originId: number;
	public get originId(): number {
		return this._originId;
	}
	public set originId(value: number) {
		if (this._originId === value)
			return;
		this._originId = value;
		if (this.portAddressOriginDestination != null)
			this.portAddressOriginDestination.originId = value;
	}

	public _portAddressOriginDestination: PortAddressOriginDestinationSelectorDto;
	public get portAddressOriginDestination(): PortAddressOriginDestinationSelectorDto {
		return this._portAddressOriginDestination;
	}
	public set portAddressOriginDestination(value: PortAddressOriginDestinationSelectorDto) {
		if (this._portAddressOriginDestination === value)
			return;
		this._portAddressOriginDestination = value;
	}

	public _actionId: string;
	public get actionId(): string {
		return this._actionId;
	}
	public set actionId(value: string) {
		if (this._actionId === value)
			return;
		this._actionId = value;
		this.routeTo();
	}


	ngAfterViewChecked(): void {
	}



	public onChangeOriginDestinationSelector($event: PortAddressOriginDestinationSelectorDto) {
		this._portAddressOriginDestination = $event;
		if ($event != null) {
			this.bookingSearchByText.portOriginId = $event.originId;
			this.bookingSearchByText.portDestinationId = $event.destinationId;
		} else {
			this.bookingSearchByText.portOriginId = 0;
			this.bookingSearchByText.portDestinationId = 0;
		}

		this._originId = this.bookingSearchByText.portOriginId;
		this._destinationId = this.bookingSearchByText.portDestinationId;

		this.loadData(true, true);
	}

	loadFilterOfMaintenaceSearchByText() {
		if (this.filterStatus != null)
			this.bookingSearchByText.activeFilterKeys = FilterStripDto.getActiveKeys(this.filterStatus);
		if (this.filterBookingTypes != null)
			this.bookingSearchByText.activeFilterKeys = this.bookingSearchByText.activeFilterKeys.concat(FilterStripDto.getActiveKeys(this.filterBookingTypes));
		this.routeTo();
	}

	loadExactKeyData(forcedsearch: boolean) {

		this.loadFilterOfMaintenaceSearchByText();

		if (!HString.isNullOrNullString(this.searchText)) {
			this.bookingsExactKey = null;
			this.bookingSearchByText.searchtext = this.searchText;
			this.bookingController.activeBookingsExactKey(this.bookingSearchByText, false).subscribe(data => {

				if (data == null) {
					this._bookings = new Array();
					return;
				}
				this.bookingsExactKey = SharedActiveBookings.wellcome(data.list, this.bookingSearchByText)

				if (this.bookingsExactKey.length == 0) {
					this.loadAproxKeyData(false);
				} else {
					this.loadData(true, false);
				}

			});

		} else {
			this.bookingsExactKey = null;
			this.loadData(true, false);
		}
	}

	loadAproxKeyData(forcedsearch: boolean) {

		this.loadFilterOfMaintenaceSearchByText();

		if (!HString.isNullOrNullString(this.searchText)) {
			this.bookingsExactKey = null;
			this.bookingSearchByText.searchtext = this.searchText;
			this.bookingController.activeBookingsAproxKey(this.bookingSearchByText, false).subscribe(data => {

				if (data == null) {
					this._bookings = new Array();
					return;
				}
				this.bookingsExactKey = SharedActiveBookings.wellcome(data.list, this.bookingSearchByText);
			});
		}
		else {
			this.bookingsExactKey = null;
		}
		this.loadData(true, false);
	}


	loadData(forcedsearch: boolean, busy: boolean) {

		//Si tenim ruta seleccionada, no te sentit fer cerca total
		if (this.bookingId > 0)
			return;

		if (this.actionId == BookingController.ACTION_ADD_BOOKING_NAME)
			return;

		this.loadFilterOfMaintenaceSearchByText();

		this.bookingSearchByText.searchtext = this.searchText;
		this.bookingSearchByText.idReserca = HDateHour.toStringSorteable(HDateHour.now());
		this.bookingSearchByText.sliceCount = this.sliceCount;
		this.bookingController.activeBookings(this.bookingSearchByText, busy).subscribe(data => {

			if (data == null) {
				this._bookings = new Array();
				return;
			}

			//Si no es la última petició feta, obiem la resposta
			if (!HString.equals(data.idReserca, this.bookingSearchByText.idReserca)) {
				return;
			}

			this._bookings = SharedActiveBookings.wellcome(data.list, this.bookingSearchByText);
			this.bookings = this._bookings;

			this.bookingsCount = data.bookingAllCount;
			if (this.bookings != null) {
				this.itemsCount = data.bookingAllCount;

				//comprovem si la seleccionada encara esta
				if (this.selectedBooking != null) {
					let findselected = false;
					let i = 0;
					while (i < this.bookings.length) {
						if (this.bookings[i].bookingId === this.selectedBooking.bookingId) {
							findselected = true;
						}
						if (findselected) {
							i = this.bookings.length;
						}
						i++;
					}
					//Si la seleccionada ja no està a la llista, la resetejem
					if (!findselected)
						this.selectedBooking = null;
				}
			} else {
				this.selectedBooking = null;
			}

			this.filterStatus = FilterStripDto.buildFromFilterStripDto(data.filterStatus);
			this.filterBookingTypes = FilterStripDto.buildFromFilterStripDto(data.filterBookingTypes);
			this.loadFilterOfMaintenaceSearchByText();

		});
	}

	public static wellcome(list: BookingCardItemDto[], maintenanceSearchByText: BookingSearchByTextDto): BookingCardItemDto[] {
		if (list != null)
			list.forEach(e => {
				e.dummySearchString = maintenanceSearchByText.searchtext;
			});

		return list;

	}

	public bookingsCount: number = 0;
	public _selectedBooking: BookingCardItemDto;
	public get selectedBooking(): BookingCardItemDto {
		return this._selectedBooking;
	}
	public set selectedBooking(value: BookingCardItemDto) {
		if (this._selectedBooking === value)
			return;
		this._selectedBooking = value;
		this._bookingId = value != null ? value.bookingId : 0;
		this.routeTo();
	}

	public itemsCount = 0;
	public sliceCount: number = SharedActiveBookings.SLICECOUNTINITIAL;
	public onSliceMore() {
		this.sliceCount = this.sliceCount + SharedActiveBookings.SLICECOUNTMORE;
		this.loadData(true, false);
	}

	getBookings() {
		if (this.bookings != null) {
			return this.bookings;
		}
		return new Array();
	}

	pretty(value) {
		return JSON.stringify(value);
	}


	onSearchFocus(event: any) {
		if (event && event.stopPropagation)
			event.stopPropagation();

	}

	onSearchClick(event: any) {
		if (event && event.stopPropagation)
			event.stopPropagation();
	}


	filterUpdate() {
		this.selectedBooking = null;
		this.loadData(true, true);
	}

	onClickItem(item: BookingCardItemDto) {
		if (item == null) {
			this.selectedBooking = null;
			return;
		}
		this.selectedBooking = item;
	}

	onClickBack(refresh: boolean) {
		this.actionId = "";
		this.selectedBooking = null;
		if (refresh || this._bookings == null || this._bookings.length == 0)
			this.loadData(true, false);
	}

	public onClickAction(event: any) {
		if (event && event.stopPropagation)
			event.stopPropagation();
		this.actionId = BookingController.ACTION_ADD_BOOKING_NAME;
	}

	public onSaveNewBooking(event: BookingCardItemDto) {
		this.selectedBooking = event;
	}


}
